module.exports = [{
      plugin: require('/zeit/a4bedf9/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":590},
    },{
      plugin: require('/zeit/a4bedf9/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-125265218-1"},
    },{
      plugin: require('/zeit/a4bedf9/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/zeit/a4bedf9/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('/zeit/a4bedf9/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
